import React from "react";
import { Link } from "react-router-dom";
import { Compass, ArrowRight } from "lucide-react";

/**
 * Employer-scoped 404 — rendered by the catch-all route inside employerRoutes.
 * Keeps the employer chrome (sidebar, top-bar) intact so a mistyped path
 * doesn't drop the user onto a blank white page (iter 72 finding).
 */
export default function EmployerNotFound() {
    return (
        <div data-testid="employer-not-found" className="max-w-lg mx-auto py-16 px-6 text-center">
            <div className="mx-auto h-14 w-14 rounded-2xl bg-gradient-to-br from-violet-500 to-emerald-500 text-white flex items-center justify-center mb-4">
                <Compass size={22} />
            </div>
            <h1 className="font-heading font-semibold text-2xl text-foreground">This page doesn&apos;t exist</h1>
            <p className="mt-2 text-sm text-muted-foreground">
                Looks like you followed a link that&apos;s been renamed or mistyped. Head back to your dashboard and everything is right where you left it.
            </p>
            <div className="mt-6 flex items-center justify-center gap-3">
                <Link
                    to="/employer/dashboard"
                    data-testid="employer-not-found-cta"
                    className="btn-primary text-sm inline-flex items-center"
                >
                    Back to dashboard <ArrowRight size={13} className="ml-2" />
                </Link>
                <Link to="/employer/jobs" data-testid="employer-not-found-jobs" className="text-sm text-muted-foreground hover:text-foreground px-3 py-1.5">
                    View jobs
                </Link>
            </div>
        </div>
    );
}
